import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGoGoLiveOptionListQueryVariables = Types.Exact<{
  serviceType?: Types.InputMaybe<Types.Scalars['String']['input']>;
  serviceType1: Types.Scalars['String']['input'];
}>;


export type GetGoGoLiveOptionListQuery = { __typename?: 'Query', goGoLiveLevelList: Array<{ __typename?: 'GoGoLiveLevelInfo', levelId: string, levelName: string }>, goGoLiveSessionList: Array<{ __typename?: 'GoGoLiveSessionInfo', sessionId: number, sessionName?: string | null }>, goGoLiveSongList: Array<{ __typename?: 'GoGoLiveSongInfo', songId: number, songName?: string | null }>, goGoLiveTalkAlongCardList: Array<{ __typename?: 'TalkAlongCardInfo', talkAlongCardId: number, cardNumber?: string | null, word?: string | null }>, goGoLiveToyList: Array<{ __typename?: 'GoGoLiveToyInfo', toyId: number, toyName?: string | null, toyImageFile?: string | null, toyImageUrl?: string | null }>, goGoLiveLessonTypeList: Array<{ __typename?: 'GoGoLiveLessonTypeInfo', lessonTypeId: number, lessonTypeName: string }> };


export const GetGoGoLiveOptionListDocument = gql`
    query GetGoGoLiveOptionList($serviceType: String, $serviceType1: String!) {
  goGoLiveLevelList {
    levelId
    levelName
  }
  goGoLiveSessionList {
    sessionId
    sessionName
  }
  goGoLiveSongList {
    songId
    songName
  }
  goGoLiveTalkAlongCardList(serviceType: $serviceType) {
    talkAlongCardId
    cardNumber
    word
  }
  goGoLiveToyList {
    toyId
    toyName
    toyImageFile
    toyImageUrl: toyImageFile @wf_blobPublicSignature(name: "GOGOLIVE_PARENT_GUIDE_IMAGES_TOY_SIGNATURE")
  }
  goGoLiveLessonTypeList(serviceType: $serviceType1) {
    lessonTypeId
    lessonTypeName
  }
}
    `;

/**
 * __useGetGoGoLiveOptionListQuery__
 *
 * To run a query within a React component, call `useGetGoGoLiveOptionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoGoLiveOptionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoGoLiveOptionListQuery({
 *   variables: {
 *      serviceType: // value for 'serviceType'
 *      serviceType1: // value for 'serviceType1'
 *   },
 * });
 */
export function useGetGoGoLiveOptionListQuery(baseOptions: Apollo.QueryHookOptions<GetGoGoLiveOptionListQuery, GetGoGoLiveOptionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoGoLiveOptionListQuery, GetGoGoLiveOptionListQueryVariables>(GetGoGoLiveOptionListDocument, options);
      }
export function useGetGoGoLiveOptionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoGoLiveOptionListQuery, GetGoGoLiveOptionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoGoLiveOptionListQuery, GetGoGoLiveOptionListQueryVariables>(GetGoGoLiveOptionListDocument, options);
        }
export type GetGoGoLiveOptionListQueryHookResult = ReturnType<typeof useGetGoGoLiveOptionListQuery>;
export type GetGoGoLiveOptionListLazyQueryHookResult = ReturnType<typeof useGetGoGoLiveOptionListLazyQuery>;
export type GetGoGoLiveOptionListQueryResult = Apollo.QueryResult<GetGoGoLiveOptionListQuery, GetGoGoLiveOptionListQueryVariables>;